import { ReactNode } from 'react';
import { Dialog, Toolbar, DialogContent, Typography } from '@mui/material';

interface ErrorDialogProps {
    open?: boolean;
    onClose?: () => void;
    message?: ReactNode;
    [key: string]: any;
}

const ErrorDialog = (props: ErrorDialogProps) => {
    const {open, onClose, message} = props;
    return <Dialog
     maxWidth="sm"
     open={open}
     onClose={onClose}
     >
         <Toolbar className='lbtoolbar'>Error</Toolbar>
         <DialogContent>
           <Typography style={{whiteSpace: 'pre-wrap'}}>{message}</Typography>
         </DialogContent>
     </Dialog>;
};

export default ErrorDialog;
